export const vehicleTypes = [
    { id: "1", name: "AUTOS" },
    { id: "2", name: "MOTOS" },
    { id: "3", name: "CAMIONES" },
    { id: "4", name: "MAQUINARIA AGRICOLA" },
    { id: "5", name: "MAQUINARIA_VIAL" },
    { id: "6", name: "ACOPLADOS" },
    { id: "7", name: "SEMI REMOLQUES" },
  ];